var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 210,
    viewBox: "0 0 316 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_4692)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 210,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1498_4692)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.123,
    cy: 132.159,
    rx: 54.1255,
    ry: 75.5403,
    transform: "rotate(-46.8241 209.123 132.159)",
    fill: "#08A045"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1498_4692)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.769,
    cy: 173.639,
    rx: 59,
    ry: 81.5,
    transform: "rotate(-41.5404 260.769 173.639)",
    fill: "#F7B801"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1498_4692",
    x: 92.7363,
    y: 17.1201,
    width: 232.773,
    height: 230.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_1498_4692"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1498_4692",
    x: 140.973,
    y: 51.1592,
    width: 239.593,
    height: 244.959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_1498_4692"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_4692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 210,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientSvg2);
export default __webpack_public_path__ + "static/media/gradientSvg2.8c81e756c70324f65ca23bf0eeede80c.svg";
export { ForwardRef as ReactComponent };